<template>
  <div id="personalDetailTab">
    <v-row>
      <v-col cols="12" v-if="isAfterSignUp">
        <v-card class="b-charcoal">
          <v-card-text>
            <div class="welcome-box-container">
              <div>
                <img src="@/assets/images/cc-logo-black.svg" />
              </div>
              <div>
                <v-row class="pl-4 pr-4 pt-2">
                  <v-col cols="12">
                    <h1>Welcome to CODE CLAN</h1>
                  </v-col>
                  <v-col cols="12">
                    <h4>Lets Get Started!</h4>
                  </v-col>
                  <v-col cols="12">
                    <span class="f-body-1">Fill out your details to Create a Profile, it should only take a few minutes. </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="f-body-1">We want to know all about your skills, talents and Experience</span>
                  </v-col>
                  <v-col cols="12">
                    <span class="f-body-1"
                      >Your Profile will Help you Find jobs, Connect with Employers, and will help us determine how code clan can best work for
                      you!</span
                    >
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="text-center text-md-left"><h1>Personal Details</h1></v-col>
      <v-col cols="12">
        <v-card class="tab-item-card personal-detail-card">
          <v-card-title v-if="!isAfterSignUp"> Personal Details </v-card-title>
          <v-form ref="frmMain" lazy-validation class="form-inputs">
            <v-card-text v-if="personalDetail">
              <InfoBox title="Start by Filling out your Personal Information ...." class="mb-5" />

              <v-row>
                <v-col cols="12" class="mb-2"><span class="f-body-1">Name</span></v-col>
                <v-col cols="12" md="4">
                  <TextField
                    :readonly="isHiringmanager"
                    dense
                    outlined
                    showRequired
                    placeholder="First name"
                    type="text"
                    :rules="[validations.required]"
                    v-model="personalDetail.FirstName"
                  />
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <TextField
                    :readonly="isHiringmanager"
                    dense
                    outlined
                    showRequired
                    placeholder="Last name"
                    type="text"
                    :rules="[validations.required]"
                    v-model="personalDetail.LastName"
                  />
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <TextField
                    :readonly="isHiringmanager"
                    dense
                    outlined
                    placeholder="Preferred Name / Nickname"
                    type="text"
                    v-model="personalDetail.NickName"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mb-2"><span class="f-body-1">Date of Birth</span></v-col>
                <v-col md="4" sm="12" cols="12">
                  <DateInputField
                    :readonly="isHiringmanager"
                    :rules="[validations.required]"
                    first-day-of-week="1"
                    v-model="personalDetail.BirthDate"
                    hide-actions
                    placeholder="Date of birth"
                    prepend-icon=""
                    :max="maxBirthDate"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mb-2"><span class="f-body-1">Location</span></v-col>
                <v-col cols="12" md="4" sm="12">
                  <AutoCompleteField
                    :readonly="isHiringmanager"
                    outlined
                    dense
                    :loading="isCountryLoading"
                    :disable="isCountryLoading"
                    :rules="[validations.required]"
                    :items="countries"
                    item-title="Name"
                    item-value="Id"
                    placeholder="Country"
                    v-model="selectedCountry"
                    @update:modelValue="resetCity()"
                  />
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <AutoCompleteField
                    :readonly="isHiringmanager"
                    :disabled="isCityLoading"
                    :loading="isCityLoading"
                    dense
                    outlined
                    placeholder="City"
                    :rules="[validations.required]"
                    :items="selectedCountryCities"
                    item-title="name"
                    item-value="name"
                    v-model="selectedCity"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mb-2"><span class="f-body-1">Nationality/Citizenship</span></v-col>
                <v-col cols="12" md="4" sm="12">
                  <AutoCompleteField
                    :readonly="isHiringmanager"
                    dense
                    outlined
                    :rules="[validations.required]"
                    :items="nationalities"
                    placeholder="Nationality"
                    v-model="personalDetail.Nationality"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mb-2"><span class="f-body-1">Email Address</span></v-col>
                <v-col cols="12" md="4" sm="12">
                  <TextField
                    :readonly="isHiringmanager"
                    dense
                    outlined
                    placeholder="Email Address"
                    showRequired
                    type="email"
                    :rules="[validations.required]"
                    v-model="personalDetail.Email"
                    disabled
                  />
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <TextField
                    :readonly="isHiringmanager"
                    dense
                    :rules="personalDetail.SecondaryEmail ? [validations.EmailCheck] : []"
                    outlined
                    placeholder="Notification Email"
                    type="email"
                    v-model="personalDetail.SecondaryEmail"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mb-2"><span class="f-body-1">Phone Number</span></v-col>
                <v-col cols="12" md="4" sm="12">
                  <TextField
                    :readonly="isHiringmanager"
                    dense
                    outlined
                    placeholder="Mobile"
                    :rules="[validations.required, validations.phoneNumber]"
                    type="text"
                    v-model="personalDetail.Phone"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
      <!-- <v-col v-if="!isAfterSignUp" md="3" sm="5" cols="12">
        <v-row>
          <v-col cols="12" sm="12" md="12" id="profilePhoto">
            <UploadProfilePhoto :isHiringmanager="isHiringmanager" :personalDetail="personalDetail" @setImage="setImage" :isFileValid="validFile" />
          </v-col>
          <v-col cols="12" sm="12" md="12" id="profileResume">
            <UploadResume
              :isHiringmanager="isHiringmanager"
              @snackbarMessage="snackbarMessage"
              :selectedTeammemberModel="selectedTeammemberModel"
              :personalDetail="personalDetail"
              :isFileValid="validResume"
              @setResume="setResume"
            />
          </v-col>
        </v-row>
      </v-col> -->
    </v-row>

    <v-card-actions v-if="isAfterSignUp">
      <div class="wizard-action">
        <v-tooltip top attach>
          <template v-slot:activator="{ props }">
            <v-btn
              class="secondary_btn"
              v-bind="props"
              @click="getAllDataAndSubmit(true)"
              :disabled="submitting"
              :loading="submitting"
              prepend-icon="mdi-check"
              >Save and exit</v-btn
            >
          </template>
          <span>You can save your progress and return to the application process later</span>
        </v-tooltip>
        <v-btn
          class="primary_btn actionButton"
          @click="getAllDataAndSubmit()"
          :disabled="submitting"
          :loading="submitting"
          append-icon="mdi-chevron-right"
          >Next</v-btn
        >
      </div>
    </v-card-actions>
    <v-card-actions v-else class="mt-6">
      <v-col md="12" class="text-center">
        <v-btn class="primary_btn actionButton" @click="submitForm" :disabled="submitting" :loading="submitting" prepend-icon="mdi-check">Save</v-btn>
      </v-col>
    </v-card-actions>
    <v-dialog v-model="showSaveForLaterConfirm" max-width="500" @keydown.esc="showSaveForLaterConfirm = false">
      <confirm-dialog :loading="submitting" :message="confirmModel" @confirm="save(true)" @cancel="cancelSaving"></confirm-dialog>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { Nationalities, MilitaryServiceSituations, EducationStatuses, MaritalStatus } from "../../definitions/constants";
import { BiographyQuestions } from "../../definitions/constants";
import UploadProfilePhoto from "./UploadProfilePhoto.vue";
import validations from "../../utils/validations";
import UploadResume from "./UploadResume.vue";
import TeamMemberService from "../../services/TeamMemberService";
import Education from "./education/Education.vue";
import { PersonalDetailModel } from "../../models/PersonalDetailModel";
import { Education as EducationModel } from "../../models/Teammember";
import ConfirmDialog from "../../components/ConfirmDialog.vue";
import AutoCompleteField from "../Fields/AutoCompleteField.vue";
import DateInputField from "../Fields/DateInputField.vue";
import TextField from "../Fields/TextField.vue";
import TextAreaFieldWithAIGenerator from "../Fields/TextAreaFieldWithAIGenerator.vue";
import { CityModel, CountryApi, CountryModel } from "../../services/openApi/api";
import InfoBox from "../InfoBox.vue";

export default defineComponent({
  props: ["personalDetailModel", "isAfterSignUp", "loading", "educations", "selectedTeammemberModel", "isHiringmanager"],
  components: {
    Education,
    UploadProfilePhoto,
    UploadResume,
    ConfirmDialog,
    AutoCompleteField,
    TextAreaFieldWithAIGenerator,
    TextField,
    DateInputField,
    InfoBox,
  },
  async mounted() {
    this.personalDetail = { ...this.personalDetailModel };
    this.selectedCountry = this.personalDetailModel.Country;
    this.selectedCity = this.personalDetailModel.City;
    if (this.personalDetail && this.personalDetail.BirthDate) {
      this.personalDetail.BirthDate = new Date(this.personalDetail.BirthDate);
    }
    this.isCountryLoading = true;
    this.countries = (await new CountryApi().getCountries()).data;
    this.isCountryLoading = false;
  },
  data() {
    return {
      countries: [] as CountryModel[],
      ddd: new Date() as Date,
      options: BiographyQuestions,
      validations,
      resumeFile: null as File | null,
      profilePhoto: null as File | null,
      validFile: true,
      validResume: true,
      isCityLoading: false,
      isCountryLoading: false,
      selectedCountry: "",
      selectedCity: "",
      gettingEducation: false,
      selectedCountryCities: [] as string[],
      nationalities: Nationalities,
      militaryServiceSituations: MilitaryServiceSituations,
      educationStatuses: EducationStatuses,
      maritalStatus: MaritalStatus,
      personalDetail: null as PersonalDetailModel | null,
      submitting: false,
      fileRules: [(v: any) => !v || v.size < 2000000 || "Your CV should be less than 2 MB!"],
      datePickerMenu: false,
      maxBirthDate: new Date(),
      educationList: [] as EducationModel[],
      confirmModel: {
        title: "",
        text: "",
      },
      showSaveForLaterConfirm: false,
    };
  },
  methods: {
    cancelSaving() {
      this.showSaveForLaterConfirm = false;
    },
    getEducations() {
      this.$emit("getEducations", "educations");
    },
    setResume(resume: any) {
      this.resumeFile = resume;
      if (!resume && this.personalDetail) {
        this.personalDetail.CV = null;
        this.validResume = false;
      }
    },
    setImage(data: any) {
      if (this.personalDetail) {
        this.personalDetail.PhotoUrl = data;
      }
    },
    snackbarMessage(msgModel: any) {
      this.$emit("snackbarMessage", msgModel);
    },
    async getAllDataAndSubmit(isForLator = false) {
      if (isForLator) {
        this.confirmModel.title = `Save Progress for Later?`;
        this.confirmModel.text =
          "You're almost ready to move on to your personalized screening experience. Are you sure you want to save your progress for later instead?";
        this.showSaveForLaterConfirm = true;
      } else {
        const isValid = (await (this.$refs.frmMain as any).validate()).valid;
        if (isValid) {
          this.save();
        } else {
          var el = document.querySelector("#personalDetailTab .v-messages.error--text:first-of-type");
          this.scrollToElement(el);
        }
      }
    },
    resetCity() {
      this.selectedCity = "";
    },
    save(isForLater = false) {
      this.submitting = true;
      if (this.personalDetail) {
        this.personalDetail.Country = this.selectedCountry;
        this.personalDetail.City = this.selectedCity;
      }
      this.$emit("submitPersonalDetail", { tm: this.personalDetail, step: !isForLater ? 1 : null });
      this.submitting = false;
      this.cancelSaving();
    },
    scrollToElement(el: any) {
      this.$emit("scrollToElement", el);
    },
    async submitForm() {
      const isValid = (await (this.$refs.frmMain as any).validate()).valid;
      this.validFile = this.personalDetail?.PhotoUrl ? true : false;
      this.validResume = this.resumeFile || this.personalDetail?.CV ? true : false;
      if (isValid && this.validFile && this.validResume) {
        this.submitting = true;
        if (this.personalDetail) {
          if (this.resumeFile) {
            this.personalDetail.CV = await TeamMemberService.uploadResume(this.resumeFile);
          }
        }
        if (this.personalDetail) {
          this.personalDetail.Country = this.selectedCountry;
          this.personalDetail.City = this.selectedCity;
        }
        this.$emit("submitPersonalDetail", { tm: this.personalDetail, step: 1 });
      } else {
        var el;
        if (!isValid) {
          el = document.querySelector("#personalDetailTab .v-messages.error--text:first-of-type");
        } else if (!this.validFile) {
          el = document.getElementById("profilePhoto");
        } else if (!this.validResume) {
          el = document.getElementById("profileResume");
        }
        this.scrollToElement(el);
      }
    },
  },
  watch: {
    educations(newVal) {
      this.educationList = newVal;
    },
    loading(newVal) {
      this.submitting = newVal;
    },
    async selectedCountry(newVal) {
      if (newVal) {
        var countryItem = this.countries.find((item: CountryModel) => item.Id == newVal);
        if (countryItem && countryItem.Id) {
          this.isCityLoading = true;
          this.selectedCountryCities = (await new CountryApi().getCities(countryItem.Id)).data.map((c: CityModel) => {
            return c.Name;
          }) as string[];
          this.isCityLoading = false;
        }
      }
    },
    personalDetailModel(newVal) {
      this.personalDetail = { ...this.personalDetailModel };
      this.selectedCountry = newVal.Country;
      this.selectedCity = newVal.City;
      if (this.personalDetail && this.personalDetail.BirthDate) {
        this.personalDetail.BirthDate = new Date(this.personalDetail.BirthDate);
      }
    },
  },
});
</script>
<style scoped lang="scss">
.personal-detail-card {
  height: 100%;
}

.welcome-box-container {
  display: flex;
  gap: 10px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .welcome-box-container {
    flex-direction: column;
    align-items: center;

    img {
      max-width: 120px;
    }

    h1,
    h4 {
      text-align: center;
    }
  }
}
</style>
